import { Select, Button, Dialog, Input } from 'components';
import { ModalButton } from './styles';
import { ConfirmDialog } from 'components/index';
import { handleCreateProductSva, handleRemoveProductSva, handleUpdateProductSva } from './requests';
import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';

const RenderAddProductSva = ({ loadData, openModalAdd, loadingData, setLoadingData, setOpenModalAdd, loading }) => {
  const [data, setData] = useState({
    name: '',
    value: '',
    charge_type: '',
    value_type: '',
    applied_automatic: false,
  });

  const resetValues = () => setData({ name: '', value: '', charge_type: '', value_type: '', applied_automatic: false });

  return (
    <Dialog open={openModalAdd} width="100%" title="Adicionar novo item">
      <Select
        id="add_type"
        name="add_type"
        height="30px"
        label="Tipo"
        value={data.charge_type}
        onChange={(e) => {
          setData({ ...data, charge_type: e.target.value });
        }}
      >
        <option value="" disabled selected>
          Selecione o tipo
        </option>
        <option value="unique">Único</option>
        <option value="periodic">Recorrente</option>
      </Select>
      <Input
        id="add_name"
        name="add_name"
        value={data.name}
        onChange={(e) => setData({ ...data, name: e.target.value })}
        label="Nome"
        height="30px"
        placeholder="Insira o nome"
      />
      <Select
        id="add_value_type"
        name="add_value_type"
        height="30px"
        label="Tipo do valor"
        value={data.value_type}
        onChange={(e) => {
          setData({ ...data, value_type: e.target.value });
        }}
      >
        <option value="" disabled selected>
          Selecione o tipo do valor
        </option>
        <option value="value">Valor fixo</option>
        <option value="percentage">Porcentagem</option>
      </Select>
      <Input
        id="add_value"
        name="add_value"
        numeric
        value={data.value}
        onChange={(e) => setData({ ...data, value: e.target.value })}
        label="Valor"
        height="30px"
        placeholder="Insira o valor"
      />
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
        <input
          type="checkbox"
          id="add_applied_automatic"
          name="add_applied_automatic"
          checked={data.applied_automatic}
          onChange={(e) => setData({ ...data, applied_automatic: e.target.checked })}
          style={{ marginRight: '8px' }}
        />
        <label htmlFor="add_applied_automatic">Aplicar para todas as vendas</label>
      </div>
      <ModalButton>
        <Button
          height="35px"
          outlined
          onClick={() => {
            resetValues();
            setOpenModalAdd(false);
          }}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          height="35px"
          onClick={() => {
            handleCreateProductSva({
              data,
              loadData,
              setOpenModalAdd,
              loading,
              loadingData,
              setLoadingData,
              resetValues,
            });
          }}
          disabled={loading || !data.name || !data.value || !data.charge_type}
          loading={loading}
        >
          {loadingData ? <ReactLoading color="#ffff" height={20} width={20} type="spin" /> : 'Adicionar'}
        </Button>
      </ModalButton>
    </Dialog>
  );
};

const RenderEditProductSva = ({
  id,
  data,
  setData,
  openModalEdit,
  setOpenModalEdit,
  loading,
  setLoading,
  loadData,
  loadingData,
  setLoadingData,
  resetValues,
}) => {
  return (
    <Dialog open={openModalEdit} width="550px" title="Editar item">
      <Select
        id="edit_type"
        name="edit_type"
        height="30px"
        label="Tipo"
        value={data.charge_type}
        onChange={(e) => {
          setData({ ...data, charge_type: e.target.value });
        }}
      >
        <option value="" disabled selected>
          Selecione o tipo
        </option>
        <option value="unique">Único</option>
        <option value="periodic">Recorrente</option>
      </Select>
      <Input
        id="edit_name"
        name="edit_name"
        value={data.name}
        onChange={(e) => setData({ ...data, name: e.target.value })}
        label="Nome"
        height="30px"
        placeholder="Insira o nome"
      />
      <Select
        id="edit_value_type"
        name="edit_value_type"
        height="30px"
        label="Tipo do valor"
        value={data.value_type}
        onChange={(e) => {
          setData({ ...data, value_type: e.target.value });
        }}
      >
        <option value="value">Valor fixo</option>
        <option value="percentage">Porcentagem</option>
      </Select>
      <Input
        id="edit_value"
        name="edit_value"
        numeric
        value={data.value}
        onChange={(e) => setData({ ...data, value: e.target.value })}
        label="Valor"
        height="30px"
        placeholder="Insira o valor"
      />
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
        <input
          type="checkbox"
          id="edit_applied_automatic"
          name="edit_applied_automatic"
          checked={data.applied_automatic}
          onChange={(e) => setData({ ...data, applied_automatic: e.target.checked })}
          style={{ marginRight: '8px' }}
        />
        <label htmlFor="edit_applied_automatic">Aplicar para todas as vendas</label>
      </div>
      <ModalButton>
        <Button
          height="35px"
          outlined
          onClick={() => {
            resetValues();
            setOpenModalEdit(false);
          }}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          height="35px"
          onClick={() => {
            handleUpdateProductSva({
              id,
              data,
              setLoading,
              setOpenModalEdit,
              loadData,
              loadingData,
              setLoadingData,
              resetValues,
            });
          }}
          disabled={loading || !data.name || !data.value || !data.charge_type}
          loading={loading}
        >
          {loadingData ? <ReactLoading color="#ffff" height={20} width={20} type="spin" /> : 'Editar'}
        </Button>
      </ModalButton>
    </Dialog>
  );
};

const renderRemoveProductSva = ({
  id,
  openModalRemove,
  setOpenModalRemove,
  loading,
  setLoading,
  loadData,
  loadingData,
  setLoadingData,
}) => (
  <ConfirmDialog
    open={openModalRemove}
    confirmLabel={loadingData ? <ReactLoading color="#ffff" height={20} width={20} type="spin" /> : 'Confirmar'}
    onCancel={() => {
      setOpenModalRemove(false);
    }}
    content="Tem certeza de que deseja excluir?"
    title="Excluir item"
    onConfirm={() => {
      handleRemoveProductSva({
        id,
        loadData,
        setLoading,
        setOpenModalRemove,
        loadingData,
        setLoadingData,
      });
    }}
    loading={loading}
  />
);

export { RenderAddProductSva, renderRemoveProductSva, RenderEditProductSva };
